<template>
  <div>
  <p class="mb-6 font-bold text-lg">{{ ezinePageModule.name ? ezinePageModule.name : 'Create New Page'}}</p>
  <div class="flex flex-wrap -mx-2 mt-4">
    <div class="w-full md:w-1/2 px-2" v-if="form.property_group_by_id !== 1">
      <label for="office">Select Office</label>
      <select v-model="ezinePageModule.office_id" @change="updateLocations" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="office in offices" :key="office.id" :value="office.id">{{ office.name }}</option>
      </select>
      <span v-if="errors.errors.office" class="text-red-600">Office field is required </span>
    </div>
    <div class="w-full md:w-1/2 px-2" v-if="((form.property_group_by_id === 1 || form.property_group_by_id === 2))">
      <h3 class="mb-3 text-base font-bold">Locations</h3>
      <div class="bg-grey-lighter border rounded p-3 mb-6">
        <h4 class="mb-3 text-sm font-bold">Included Locations</h4>
        <!-- Locations -->
        <div class="mb-3" v-for="(location, index) in filteredLocations" :key="index">
          <input type="checkbox" :id="index" v-model="ezinePageModule.locations" :value="location">
          <label :for="index" class="w-full ml-2">{{ location }} </label>
        </div>
      </div>
      <span v-if="errors.errors.location" class="text-red-600">Location field is required </span>
    </div>
  </div>
  <div class="flex flex-wrap -mx-2 mt-4">
    <div class="w-full md:w-1/2 px-2">
      <label for="office">Department</label>
      <select v-model="ezinePageModule.data.rental" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option :value="false">Sales</option>
        <option :value="true">Lettings</option>
      </select>
    </div>
    <div class="w-full md:w-1/2 px-2" v-if="ezinePageModule.data.rental">
      <label for="office">Student Lettings</label>
      <select v-model="ezinePageModule.data.student_lettings" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="studentLetting in studentLettingsList" :key="studentLetting.id" :value="studentLetting.id">{{ studentLetting.name }}</option>
      </select>
    </div>
  </div>
  <div class="flex flex-wrap -mx-2 mt-4">
    <div class="w-full md:w-1/2 px-2">
      <label for="office">Lifestyle Tag</label>
      <span class="caret-down">
        <select v-model="ezinePageModule.data.tags" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          <option value=null>No Filter</option>
          <option v-for="(tag,index) in tagList" :key="index" :value="tag.name">{{ tag.name }}</option>
        </select>
      </span>
    </div>
    <div class="w-full md:w-1/2 px-2">
      <h3 class="mb-3 text-base font-bold">Property Types</h3>
      <div class="bg-grey-lighter border rounded p-3 mb-6">
        <h4 class="mb-3 text-sm font-bold">Included Properties</h4>
        <!-- PROPERTY TYPES -->
        <div class="mb-3" v-for="propertyTypeGroup in propertyTypeGroups" :key="propertyTypeGroup.id">
          <input type="checkbox" :id="`propertyType.${propertyTypeGroup.id}`" v-model="ezinePageModule.data.property_type_group_ids" :value="propertyTypeGroup.id">
          <label :for="`propertyType.${propertyTypeGroup.id}`">{{ propertyTypeGroup.name }}</label>
        </div>
      </div>
    </div>
  </div>
    <div class="flex justify-end mt-6">
      <button @click="save()" class="bg-primary rounded py-3 px-12 text-white">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapActions } from 'vuex'
import randomstring from 'randomstring'
import ErrorBag from '@/ErrorBag'
export default {
  props: {
    offices: Array,
    ezinePageModule: Object,
    pageGroups: Array,
    form: Object,
    studentLettingsList: Array
  },
  data () {
    return {
      tagList: [],
      modules: [],
      filteredLocations: [],
      errors: new ErrorBag(),
      propertyTypeGroups: [
        { id: 0, name: 'Not Specified' },
        { id: 1, name: 'House' },
        { id: 2, name: 'Flat / Apartment' },
        { id: 3, name: 'Bungalow' },
        { id: 4, name: 'Character Property' },
        { id: 5, name: 'Commercial Property' },
        { id: 6, name: 'Garage / Parking' },
        { id: 7, name: 'Guest House / Hotel' },
        { id: 8, name: 'House / Flat Share' },
        { id: 9, name: 'Land' },
        { id: 10, name: 'Mobile / Park Home' },
        { id: 11, name: 'Retirement Property' }
      ]
    }
  },
  created () {
    this.getTags()
    this.getModules()
    if (this.offices.length > 0 && (this.form.property_group_by_id === 1 || this.form.property_group_by_id === 2)) {
      this.updateLocations()
    }
  },
  computed: {
    propertyPageGroupId () {
      return Array.isArray(this.pageGroups) ? this.pageGroups.find((group) => group.type_id === 1).id : null
    },
    propertyModule () {
      const mod = this.modules.find((m) => m.component === 'properties-module')

      return mod ? {
        id: mod.id,
        locked: mod.locked,
        component: mod.component
      } : null
    }
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    prevent (e) {
      e.preventDefault()
    },
    getTags () {
      v2Api.get('lifestyle-tags').then((response) => {
        this.tagList = response.data
        // this.tagList.push({
        //   id: null,
        //   name: 'No filter'
        // })
      }, (errors) => {
      })
    },
    save () {
      // Vaidate office
      if (!this.ezinePageModule.office_id && this.form.property_group_by_id !== 1) {
        this.errors.store({
          errors: { office: ['Office is required'] }
        })
        return
      }
      // Validate location
      if (this.ezinePageModule.locations.length === 0 && (this.form.property_group_by_id === 1 || this.form.property_group_by_id === 2)) {
        this.errors.store({
          errors: { location: ['Location is required'] }
        })
        return
      }
      this.errors.clear()
      let officeId = this.ezinePageModule.office_id ? this.ezinePageModule.office_id : (this.offices ? this.offices[0].id : null)
      let office = this.offices.find((o) => o.id === officeId) || null
      // if the “Property Pages Displayed By” option is Location or Offices and Locations
      if (this.form.property_group_by_id === 1 || this.form.property_group_by_id === 2) {
        let updatedOffice = this.form.property_group_by_id === 1 ? null : office
        this.addOrUpdatePropertyPage(updatedOffice, this.ezinePageModule.locations, this.ezinePageModule.data.rental, this.ezinePageModule.data.property_type_group_ids, this.ezinePageModule.data.tags, this.ezinePageModule.data.student_lettings)
      } else {
        this.addOrUpdatePropertyPage(office, null, this.ezinePageModule.data.rental, this.ezinePageModule.data.property_type_group_ids, this.ezinePageModule.data.tags, this.ezinePageModule.data.student_lettings)
      }
      this.$emit('close')
    },
    addOrUpdatePropertyPage (office, location, rental, groupIds, tags, studentLetting) {
      const isLocationArray = Array.isArray(location)

      // Create the modules array
      const modules = isLocationArray ? location.map(loc => ({
        ezine_module_id: this.propertyModule.id,
        module: this.propertyModule,
        office_id: office ? office.id : null,
        data: {
          location: loc,
          rental: rental,
          background_colour: 'bg-white',
          property_type_group_ids: groupIds,
          tags: tags,
          student_lettings: studentLetting
        }
      })) : [{
        ezine_module_id: this.propertyModule.id,
        module: this.propertyModule,
        office_id: office ? office.id : null,
        data: {
          location: location,
          rental: rental,
          background_colour: 'bg-white',
          property_type_group_ids: groupIds,
          tags: tags,
          student_lettings: studentLetting
        }
      }]
      const newPage = {
        ref: this.ezinePageModule.ref ? this.ezinePageModule.ref : randomstring.generate(), // Generate a random reference for a new page
        content_type: 'App\\Models\\EzinePage',
        content: {
          ezine_page_group_id: this.propertyPageGroupId,
          name: office ? `Property - ${office.address_town} Office (${rental ? 'Lettings' : 'Sales'})` : `Property Page (${rental ? 'Lettings' : 'Sales'})`,
          modules: modules
        }
      }

      // Check if there's an existing page with the same reference
      const existingPageIndex = this.form.pages.findIndex(page => page.ref === this.ezinePageModule.ref)

      if (existingPageIndex !== -1) {
        // Update existing page
        this.$set(this.form.pages, existingPageIndex, newPage)
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Saved',
          info: 'Property page updated successfully'
        })
      } else {
        // Add new page
        this.form.pages.push(newPage)
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Saved',
          info: 'Property page added successfully'
        })
      }
    },
    getModules () {
      v2Api.get(`/ezine-modules`).then((response) => {
        this.modules = response.data
      })
    },
    updateLocations  () {
      // Show selected office's location
      if (this.form.property_group_by_id === 2) {
        const office = this.offices.find(o => o.id === this.ezinePageModule.office_id)
        this.filteredLocations = office ? office.locations : []
      } else {
        this.filteredLocations = this.offices.reduce((allLocations, office) => {
          allLocations.push(...office.locations)
          return allLocations
        }, [])
      }
      this.ezinePageModule.locations = this.ezinePageModule.locations.filter(location =>
        this.filteredLocations.includes(location)
      )
    }
  },
  watch: {
    form: {
      handler () {
        this.$emit('input', this.form)
      },
      deep: true
    }
  }
}
</script>
